"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryScatter", {
  enumerable: true,
  get: function () {
    return _victoryScatter.default;
  }
});

var _victoryScatter = _interopRequireDefault(require("./victory-scatter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-scatter/lib/index.js
// module id = 1898
// module chunks = 0